<app-material>
    <div class="header" header>
        <div class="title">
            <h2>{{ 'atom.tool-requests-lines.process.title' | translate }}</h2>
            <div class="mutators">
                <app-icon class="expand" library="material"
                          variant="{{this.allExpanded ? 'keyboard_arrow_up': 'keyboard_arrow_down' }}"
                          (click)="toggleExpanded()"></app-icon>
                <app-icon library="material" variant="filter_list" (click)="toggleFilters()"></app-icon>
            </div>
        </div>
        <section *ngIf="selectedToolRequestDetails"
                 class="tool-request-details">
            <app-display-label
                label="{{'atom.tool-requests-lines.process.labels.toolRequestName' | translate}}"
                [value]="selectedToolRequestDetails?.name"></app-display-label>
            <app-display-label
                label="{{'atom.tool-requests-lines.process.labels.dateRequested' | translate}}"
                [value]="selectedToolRequestDetails?.createdDate"></app-display-label>
            <app-display-label
                label="{{'atom.tool-requests-lines.process.labels.createdBy' | translate}}"
                [value]="selectedToolRequestDetails?.createdBy.fullName"></app-display-label>
            <app-display-label
                label="{{'atom.tool-requests-lines.process.labels.manufacturingLine' | translate}}"
                [value]="selectedToolRequestDetails?.line?.name"></app-display-label>
            <app-display-label
                label="{{'atom.tool-requests-lines.process.labels.partNumber' | translate}}"
                [value]="getPartNumberName()"></app-display-label>
            <app-display-label
                label="{{'atom.tool-requests-lines.process.labels.hasPriority' | translate}}"
                [value]="selectedToolRequestDetails?.highPriority"></app-display-label>
            <app-display-label
                label="{{'atom.tool-requests-lines.process.labels.priorityReason' | translate}}"
                [value]="selectedToolRequestDetails?.priorityReason"></app-display-label>
            <app-display-label
                label="{{'atom.tool-requests-lines.process.labels.insertionCycle' | translate}}"
                [value]="selectedToolRequestDetails?.insertionCycle.name"></app-display-label>
        </section>
    </div>
    <div class="body" body>
        <app-tool-request-lines-tools-table
            *ngIf="selectedToolRequestDetails"
            [rowExpand]="true"
            [isLoading]="toolsLoading"
            [tableConfig]="tableConfig"
            [tools]="selectedToolRequestTools"
            [isMaterial]="false"
            [hasTitle]="false"
            [showFilters]="showFilters"
            [replacementTools]="replacementTools"
            (sortChange)="onSortChange($event)"
            (filterChange)="onFilter($event)"
            (pageChange)="onPageChange($event)"
            (replaceTool)="onToolReplace($event)">
        </app-tool-request-lines-tools-table>
    </div>
    <div *ngIf="selectedToolRequestDetails" class="footer" footer>
        <div *ngIf="needConsent" class="consent">
            <app-input-switch [(ngModel)]="consent"></app-input-switch>
            {{ 'atom.tool-requests-lines.process.consent'| translate }}
        </div>
        <div>
            <app-alert *ngIf="requestContainsUnavailableTools"
                       type="error"
                       [responsive]="true"
                       message="{{'atom.tool-requests-lines.process.error.requestContainsUnavailableTools'| translate}}"></app-alert>
            <app-alert *ngIf="selectedToolRequestDetails?.toolRequestToBeApproved "
                       type="custom"
                       [responsive]="true">
                <ng-template #error>
                    {{ 'atom.tool-requests-lines.process.error.toolRequestNotApprovable' | translate }}
                    <a class="open-tool-request-link"
                       (click)="openToolRequest(selectedToolRequestDetails)"> {{ selectedToolRequestDetails?.toolRequestToBeApproved?.name }}</a>
                </ng-template>
            </app-alert>
            <app-alert *ngIf="hasToolsInTransport && hasToolsReservedForLine && !requestContainsUnavailableTools"
                type="error"
                [responsive]="true"
                message="{{'atom.tool-requests-lines.process.error.toolsInTransport'| translate}}">
            </app-alert>
            <app-alert
                *ngIf="selectedToolRequestDetails?.toolRequestsToBeClosed?.length > 0 && !requestContainsUnavailableTools"
                type="info"
                [responsive]="true"
                message="{{'atom.tool-requests-lines.process.info.toolRequestsToBeClosed'|
                            translate: {toolRequestsToBeClosed: getToolRequestsToBeClosed()} }}">
            </app-alert>
        </div>
        <div class="buttons">
            <app-loading-spinner *ngIf="isLoading" class="loading-animation"></app-loading-spinner>
            <app-button *ngIf="!isLoading"
                        type="simple"
                        class="back"
                        [disabled]="isLoading"
                        (clicked)="onBack()">
                {{ 'generic.buttons.back' | translate }}
            </app-button>
            <div *ngIf="selectedToolRequestDetails" class="buttons">
                <app-button
                    type="primary"
                    [class.disabled]="!canPerformApprove()"
                    (clicked)="approveToolRequest()"
                    [disabled]="isLoading">
                    {{ 'generic.buttons.approve' | translate }}
                </app-button>
                <app-button type="danger"
                            [class.disabled]=!selectedToolRequestDetails?.isApprovable
                            (clicked)="rejectToolRequest()"
                            [disabled]="isLoading">
                    {{ 'generic.buttons.reject' | translate }}
                </app-button>
            </div>
        </div>
    </div>
</app-material>

<app-replace-tool-modal
    [isLoading]="isLoading"
    (confirmButtonPressed)="onConfirmReplace($event)"
    (onRepairButtonPressed)="onRepair($event)"
    [hasCancel]="true"
    title="{{'atom.tool-requests-lines.replaceTools.modal.title' | translate}}"
    message="{{'atom.tool-requests-lines.replaceTools.modal.message' | translate}}"
    [replacementTools]="replacementTools">
</app-replace-tool-modal>

<app-confirmation-modal [isConfirmationInProgress]="isConfirmationInProgress"
                        [title]="'atom.tool-requests-lines.forms.rejectReason' | translate"
                        [displayReasonLabel]="'atom.tool-requests-lines.forms.rejectReason' | translate"
                        [displayReasonPlaceholder]="'atom.tool-requests-lines.forms.reasonMessage' | translate"
                        [reasonMandatory]="true"
                        [confirmWithReason]="true"
                        (confirmEvent)="onConfirmReject($event)">
</app-confirmation-modal>
